define(["require", "exports", "jquery", "knockout", "log", "../../utils/kendoUtils", "../../utils/tools", "../../models/UserContext", "../../shared/dataLogs", "../phoneNumbers/phoneNumberActions", "../../models/E911DetailsModel", "../../models/CustomerModel", "../import/import", "../../utils/urls"], function (require, exports, $, ko, log, KendoUtils, tools, UserContext, DataLogs, PhoneNumberActions, E911DetailsModel, CustomerModel, Import, urls_1) {
    "use strict";
    var CustomerPhoneNumbers = /** @class */ (function () {
        function CustomerPhoneNumbers(customerId, customerModel, lookupLists, initGridCallback) {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,PhoneNumbers.Delete"));
            this.userCanAddPhone = ko.observable(UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete"));
            this.userCanDeleteE911 = ko.observable(UserContext.hasAccess("Admin,E911.Delete"));
            this.userCanUpdateE911 = ko.observable(UserContext.hasAccess("Admin,E911.Add,E911.Delete"));
            this.userCanViewE911 = ko.observable(UserContext.hasAccess("Admin,E911.View,E911.Add,E911.Delete"));
            this.importModule = new Import();
            this.phoneActions = new PhoneNumberActions();
            this.customerId = ko.observable(0);
            this.phoneNumbersViewType = ko.observable('group');
            //phone numbers filters
            this.filterClearInProgress = ko.observable();
            this.filterPhoneByAny = ko.observable();
            this.filterPhoneByEntityName = ko.observable();
            this.filterPhoneByStatusId = ko.observable();
            this.filterPhoneProviderId = ko.observable();
            this.filterPhoneTypeId = ko.observable();
            this.filterPhoneHasE911 = ko.observable(false);
            this.filterPhoneSmsEnabled = ko.observable(false);
            this.filterPhoneCampaignId = ko.observable();
            this.editE911DetailsModel = ko.observable(new E911DetailsModel());
            this.editCustomerModel = ko.observable(new CustomerModel());
            var self = this;
            self.customerId(customerId);
            self.editCustomerModel = customerModel;
            self.lookupLists = lookupLists;
            self.initExportDataSource();
            self.addPhoneGridActionButtons();
            self.initGridCallback = initGridCallback;
            if (self.initGridCallback) {
                self.initGridCallback(self);
            }
        }
        CustomerPhoneNumbers.prototype.refreshTable = function () {
            var _a;
            var self = this;
            (_a = self.customerPhoneNumbersTable) === null || _a === void 0 ? void 0 : _a.refresh();
        };
        CustomerPhoneNumbers.prototype.initGrid = function () {
            var self = this;
            self.initCustomerPhoneNumbers();
            self.initPhonesMenu();
            ko.applyBindings(self, document.getElementById("divNumbersTable"));
        };
        CustomerPhoneNumbers.prototype.initExportDataSource = function () {
            var self = this;
            self.e911Datasource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: "/Customers/GetE911Details",
                        type: "POST",
                        data: function () {
                            var data = {};
                            data.id = self.customerId();
                            return data;
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.lookupLists.GridStructures.E911DetailsStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            });
            self.phoneNumbersDataSourceOptions = {
                transport: {
                    read: {
                        url: "/Customers/GetPhoneNumbers?id=" + self.customerId(),
                        type: "POST",
                        data: function () {
                            return self.prepareFilterData();
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.lookupLists.GridStructures.PhoneNumbersStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.phoneNumbersDataSource = new kendo.data.DataSource(self.phoneNumbersDataSourceOptions);
        };
        CustomerPhoneNumbers.prototype.initCustomerPhoneNumbers = function () {
            var self = this;
            var gridStructure;
            if (self.phoneNumbersViewType() === 'group') {
                gridStructure = self.lookupLists.GridStructures.PhoneNumberGroupsStructure;
            }
            else {
                gridStructure = self.lookupLists.GridStructures.PhoneNumbersStructure;
            }
            var columns = gridStructure.columns;
            if (self.customerPhoneNumbersTable) {
                self.customerPhoneNumbersTable.destroyGrid();
            }
            self.customerPhoneNumbersTable = new KendoUtils.KendoUtils();
            var gridOptions;
            if (self.phoneNumbersViewType() === 'group') {
                gridOptions = self.getGroupedPhoneGridOptions(gridStructure, columns);
            }
            else {
                gridOptions = self.getPlainPhoneGridOptions(gridStructure, columns);
            }
            self.customerPhoneNumbersTable.initGrid(gridOptions);
            self.filterPhoneByAny.subscribe(function () {
                if (self.filterClearInProgress()) {
                    return;
                }
                self.customerPhoneNumbersTable.refresh();
            });
            self.filterPhoneByEntityName.subscribe(function () {
                if (self.filterClearInProgress()) {
                    return;
                }
                self.customerPhoneNumbersTable.refresh();
            });
            self.filterPhoneByStatusId.subscribe(function () {
                if (self.filterClearInProgress()) {
                    return;
                }
                self.customerPhoneNumbersTable.refresh();
            });
            self.filterPhoneProviderId.subscribe(function () {
                if (self.filterClearInProgress()) {
                    return;
                }
                self.customerPhoneNumbersTable.refresh();
            });
            self.filterPhoneTypeId.subscribe(function () {
                if (self.filterClearInProgress()) {
                    return;
                }
                self.customerPhoneNumbersTable.refresh();
            });
            self.filterPhoneHasE911.subscribe(function () {
                if (self.filterClearInProgress()) {
                    return;
                }
                self.customerPhoneNumbersTable.refresh();
            });
            self.filterPhoneSmsEnabled.subscribe(function () {
                if (self.filterClearInProgress()) {
                    return;
                }
                self.customerPhoneNumbersTable.refresh();
            });
            self.filterPhoneCampaignId.subscribe(function () {
                if (self.filterClearInProgress()) {
                    return;
                }
                self.customerPhoneNumbersTable.refresh();
            });
            $("#divNumbersTable tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.phoneActions.editPhoneNumber(data.Id, data.Number, self.customerId());
                event.preventDefault();
            }).on("click", ".btn-add", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editE911Details(undefined, data.Id, data.Number);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.phoneActions.deleteNumberConfirm(data.Id, data.HasE911, data.Number);
                event.preventDefault();
            }).on("click", ".btn-edit-fax-settings", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.phoneActions.editFaxSettings(data.Id, data.Number);
                event.preventDefault();
            }).on("click", ".btn-activate", function (event) {
                var locationId = $(this).data("id");
                self.activateE911LocationConfirm(locationId);
                event.preventDefault();
            }).on("click", ".btn-remove911", function (event) {
                var locationId = $(this).data("id");
                self.phoneActions.removeE911LocationConfirm(locationId);
                event.preventDefault();
            }).on("click", ".numberLogs", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                var dataLogs = new DataLogs("PhoneNumber", data.Id);
                dataLogs.open("Phone number logs: " + data.Number);
                event.preventDefault();
            }).on("click", ".numberHistory", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var dataLogs = new DataLogs("PhoneNumber", data.Id);
                dataLogs.openPhoneNumberHistory(data.Number, "Phone number logs: " + data.Number);
                event.preventDefault();
            });
        };
        CustomerPhoneNumbers.prototype.getGroupedPhoneGridOptions = function (gridStructure, columns) {
            var self = this;
            return {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Customers/GetPhoneNumberGroups?id=" + self.customerId(),
                            type: "POST",
                            data: function () {
                                return self.prepareFilterData();
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#customersphones-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    scrollable: true,
                    height: 600,
                    detailInit: self.initPhoneDetailsGrid.bind(self)
                },
                gridId: "divNumbersTable",
                showPagerOnTop: true
            };
        };
        CustomerPhoneNumbers.prototype.getPlainPhoneGridOptions = function (gridStructure, columns) {
            var self = this;
            return {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Customers/GetPhoneNumbers?id=" + self.customerId(),
                            type: "POST",
                            data: function () {
                                return self.prepareFilterData();
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: self.lookupLists.GridStructures.PhoneNumbersStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    serverAggregates: false
                },
                gridOptions: {
                    toolbar: kendo.template($("#customersphones-toolbar-template").html()),
                    resizable: true,
                    columns: gridStructure.columns,
                    dataBound: function (e) {
                        var dataSource = e.sender.dataSource;
                        e.sender.element.find("tr.k-master-row").each(function (index, elm) {
                            var row = $(elm);
                            var data = dataSource.getByUid(row.data(kendo.ns + "uid"));
                            // this example will work if ReportId is null or 0 (if the row has no details)
                            if (!data.get("HasE911")) {
                                row.find(".k-hierarchy-cell a").css({ opacity: 0.3, cursor: "default" }).click(function (e) {
                                    e.stopImmediatePropagation();
                                    return false;
                                });
                            }
                        });
                    },
                    scrollable: true,
                    height: 600,
                    detailInit: self.phoneDetailInit
                },
                gridId: "divNumbersTable",
                showPagerOnTop: true
            };
        };
        CustomerPhoneNumbers.prototype.initPhoneDetailsGrid = function (e) {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.PhoneNumbersStructure;
            var grid = new KendoUtils.KendoUtils();
            $("<div/>").attr('id', e.data.NumberGroup).appendTo(e.detailCell);
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Customers/GetPhoneNumbers?id=" + self.customerId(),
                            type: "POST",
                            data: function () {
                                var data = self.prepareFilterData();
                                data.numberGroup = e.data.NumberGroup;
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    resizable: true,
                    columns: gridStructure.columns,
                    dataBound: function (e) {
                        var dataSource = e.sender.dataSource;
                        e.sender.element.find("tr.k-master-row").each(function (index, elm) {
                            var row = $(elm);
                            var data = dataSource.getByUid(row.data(kendo.ns + "uid"));
                            // this example will work if ReportId is null or 0 (if the row has no details)
                            if (!data.get("HasE911")) {
                                row.find(".k-hierarchy-cell a").css({ opacity: 0.3, cursor: "default" }).click(function (e) {
                                    e.stopImmediatePropagation();
                                    return false;
                                });
                            }
                        });
                    },
                    detailInit: self.phoneDetailInit
                },
                gridId: e.data.NumberGroup,
                showPagerOnTop: true
            };
            grid.initGrid(gridOptions);
        };
        CustomerPhoneNumbers.prototype.prepareFilterData = function () {
            var self = this;
            var data = {};
            if (self.filterPhoneByAny()) {
                data.filterText = self.filterPhoneByAny();
            }
            if (self.filterPhoneByEntityName()) {
                data.entityName = self.filterPhoneByEntityName();
            }
            if (self.filterPhoneProviderId() && self.filterPhoneProviderId() > 0) {
                data.providerId = self.filterPhoneProviderId();
            }
            if (self.filterPhoneTypeId() && self.filterPhoneTypeId() > 0) {
                data.typeId = self.filterPhoneTypeId();
            }
            if (self.filterPhoneByStatusId() && self.filterPhoneByStatusId() > 0) {
                data.statusId = self.filterPhoneByStatusId();
            }
            data.e911Only = self.filterPhoneHasE911();
            data.smsEnabled = self.filterPhoneSmsEnabled();
            if (self.filterPhoneCampaignId()) {
                data.campaignId = self.filterPhoneCampaignId();
            }
            return data;
        };
        CustomerPhoneNumbers.prototype.phoneDetailInit = function (e) {
            var detailRow = e.detailRow;
            var data = e.data;
            if (!data.E911Details) {
                return;
            }
            var html = "<td></td><td colspan='9'>";
            for (var i = 0; i < data.E911Details.length; i++) {
                var details = data.E911Details[i];
                html += '<div style="margin:10px; min-width: 165px; display: inline-block"><span class="addess-details"' + (details.IsDefaultAddress ? 'style="background-color:#87b87f;color:white"' : "") + ">"
                    + details.CallerName + "<br/><br/>"
                    + details.AddressLine1 + " "
                    + (details.AddressLine2 ? details.AddressLine2 + "<br/>" : "<br/>")
                    + details.Community + " " + details.State + " " + details.ZipCode + "<br/><br/>";
                if (!details.IsDefaultAddress && UserContext.hasAccess("Admin,E911.Add,E911.Delete")) {
                    html = html + '<button class="btn btn-sm btn-success btn-activate" href="#" data-id="' + details.LocationId + '">Activate</button>&nbsp;';
                }
                if (UserContext.hasAccess("Admin,E911.Delete")) {
                    html = html + '<button class="btn btn-sm btn-danger btn-remove911" href="#" data-id="' + details.LocationId + '">Delete</button>';
                }
                html = html + "</span></div>";
            }
            html += "<td>";
            detailRow.html(html);
        };
        CustomerPhoneNumbers.prototype.changePhonesView = function () {
            var self = this;
            self.phoneNumbersViewType(self.phoneNumbersViewType() === 'group' ? 'plain' : 'group');
            self.initCustomerPhoneNumbers();
        };
        CustomerPhoneNumbers.prototype.formatPhoneDetails = function (data) {
            if (!data.E911Details) {
                return "";
            }
            var html = "";
            for (var i = 0; i < data.E911Details.length; i++) {
                var details = data.E911Details[i];
                html += '<span class="addess-details"' + (details.IsDefaultAddress ? 'style="background-color:#87b87f;color:white"' : "") + ">"
                    + details.AddressLine1 + "<br/>"
                    + (details.AddressLine2 ? details.AddressLine2 + "<br/>" : "<br/>")
                    + details.Community + " " + details.State + " " + details.ZipCode + "<br/><br/>";
                if (!details.IsDefaultAddress && UserContext.hasAccess("Admin,E911.Add")) {
                    html = html + '<button class="btn btn-sm btn-success btn-activate" href="#" data-id="' + details.LocationId + '">Activate</button>&nbsp;';
                }
                if (UserContext.hasAccess("Admin,E911.Delete")) {
                    html = html + '<button class="btn btn-sm btn-danger btn-remove911" href="#" data-id="' + details.LocationId + '">Delete</button>';
                }
                html = html + "</span>";
            }
            return html;
        };
        CustomerPhoneNumbers.prototype.addPhoneGridActionButtons = function () {
            var self = this;
            //add actions column
            var actions = {
                field: "",
                width: "265px",
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete")) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i>Edit</a>';
                    }
                    if (dataItem.ProviderName == 'VT-eFax' && UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete")) {
                        html += '&nbsp;<a class="btn btn-sm btn-info btn-edit-fax-settings" href="#"><i class="fa fa-edit "></i>Fax Settings</a>';
                    }
                    if (UserContext.hasAccess("Admin,E911.Add,E911.Delete")) {
                        html += '&nbsp;<button class="btn btn-sm btn-info btn-add" href="#"><i class="fa fa-edit "></i>Add E911</button>';
                    }
                    if ((UserContext.hasAccess("Admin,PhoneNumbers.Delete") && !dataItem.HasE911)
                        || (UserContext.hasAccess("Admin,E911.Delete") && UserContext.hasAccess("Admin,PhoneNumbers.Delete") && dataItem.HasE911)) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i>Delete</button>';
                    }
                    return html;
                }
            };
            self.lookupLists.GridStructures.PhoneNumbersStructure.columns.push(actions);
        };
        CustomerPhoneNumbers.prototype.filterPhoneByAnyOnChange = function (self, elm, e) {
            console.log(self, elm, e);
            var inputNumber = elm.target.value;
            var containsPattern = /[a-zA-Z]/i;
            var patt = containsPattern.test(inputNumber) ? /[]/g : /[-+(). ]/g;
            if (patt.test(inputNumber)) {
                inputNumber = inputNumber.replace(patt, "");
                self.filterPhoneByAny(inputNumber);
            }
        };
        CustomerPhoneNumbers.prototype.importPhoneNumbers = function () {
            var self = this;
            self.importModule.editModel().CustomerId(self.editCustomerModel().Id());
            self.importModule.editModel().CustomerName(self.editCustomerModel().Name());
            self.importModule.importPhoneNumbers(function () {
                self.refreshTable();
                // todo? self.customerLocationsTable.refresh();
            });
        };
        CustomerPhoneNumbers.prototype.updateE911DetailsConfirm = function () {
            var self = this;
            tools.confirmModal({
                title: "Update Customer E911 Details",
                text: "Are you sure you want to Update customer E911 Details?",
                buttonTitle: "Update",
                type: "info",
                modalOptions: {},
            }, function (modal) {
                $(modal).modal("hide");
                self.updateE911Details();
            });
        };
        CustomerPhoneNumbers.prototype.updateE911Details = function () {
            var self = this;
            var btn1 = $("#updateE911FromApi").button("loading");
            tools.ajaxPost({
                url: "/E911/UpdateCustomerE911AddressDetails",
                data: { customerId: self.customerId() }
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.refreshTable();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                btn1.button("reset");
            });
        };
        CustomerPhoneNumbers.prototype.clearPhonesFilter = function () {
            var self = this;
            self.filterClearInProgress(true);
            self.filterPhoneByAny("");
            self.filterPhoneByEntityName("");
            self.filterPhoneByStatusId(null);
            self.filterPhoneProviderId(null);
            self.filterPhoneTypeId(null);
            self.filterPhoneHasE911(false);
            self.filterPhoneSmsEnabled(false);
            self.filterPhoneCampaignId(null);
            self.filterClearInProgress(false);
            self.customerPhoneNumbersTable.refresh();
        };
        CustomerPhoneNumbers.prototype.initPhonesMenu = function () {
            var self = this;
            setTimeout(function () {
                var element = document.getElementById("divNumbersTable");
                $("#menu", element).kendoMenu();
                // get a reference to the menu widget
                var menu = $("#menu", element).data("kendoMenu");
                // bind to the select event
                menu.bind("select", function (e) {
                    // handle event
                    var actionName = $(e.item).data("action");
                    if (actionName) {
                        self[actionName]();
                    }
                });
            });
        };
        CustomerPhoneNumbers.prototype.editE911Details = function (e911Id, phoneId, phoneNumber) {
            var self = this;
            tools.editModal({
                title: "Edit E911 Details",
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveE911Details(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(e911Id)) {
                        getModelCall = tools.ajaxGet({
                            url: urls_1.urls.getPhoneNumberById,
                            data: { id: e911Id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editE911DetailsModel(new E911DetailsModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editE911DetailsModel(new E911DetailsModel());
                        self.editE911DetailsModel().PhoneNumberId(phoneId);
                        self.editE911DetailsModel().Uri(phoneNumber);
                        self.editE911DetailsModel().TelephoneNumber(phoneNumber);
                        self.editE911DetailsModel().CustomerId(self.editCustomerModel().Id());
                        self.editE911DetailsModel().CustomerName(self.editCustomerModel().Name());
                        self.editE911DetailsModel().IsCustomerDefined(true);
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'e911-edit-template', data: editE911DetailsModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerPhoneNumbers.prototype.saveE911Details = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editE911DetailsModel);
            obj["__RequestVerificationToken"] = $('#mainCustomerForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/E911/SaveE911AddressDetails",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.refreshTable();
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerPhoneNumbers.prototype.activateE911LocationConfirm = function (locationId) {
            var self = this;
            tools.confirmModal({
                title: "Activate E911 Location",
                text: "Are you sure you want to Activate customer E911 location?",
                buttonTitle: "Activate",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.activateE911Location(locationId);
            });
        };
        CustomerPhoneNumbers.prototype.activateE911Location = function (locationId) {
            var self = this;
            var data = {
                locationId: locationId
            };
            tools.ajaxPost({
                url: "/E911/ProvisionLocationJson",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Location Activated successfully");
                    self.refreshTable();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        return CustomerPhoneNumbers;
    }());
    return CustomerPhoneNumbers;
});
//# sourceMappingURL=customerPhoneNumbers.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerPhoneNumbers.js
// module id = 189
// module chunks = 2